import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, dashboardPathFor } from '../lib/auth';
import { apiError } from '../lib/api';

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:'', email:'', password:'', phone:'', role:'customer' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setBusy(true);
    try {
      const u = await register(form);
      nav(dashboardPathFor(u.role));
    } catch (e) { setErr(apiError(e, 'Registration failed')); }
    finally { setBusy(false); }
  };

  return (
    <div className="container my-5" style={{maxWidth: 520}} data-testid="register-page">
      <h1>Create your account</h1>
      <p className="text-muted-2">Sign up as a customer to send enquiries, or as a business owner to list.</p>
      <div className="ap-card mt-3">
        {err && <div className="alert alert-danger" data-testid="register-error">{err}</div>}
        <form onSubmit={submit} data-testid="register-form">
          <label className="form-label">Full name</label>
          <input className="form-control mb-3" required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} data-testid="reg-name" />
          <label className="form-label">Email</label>
          <input className="form-control mb-3" type="email" required value={form.email} onChange={e=>setForm({...form,email:e.target.value})} data-testid="reg-email" />
          <label className="form-label">Password (6+ chars)</label>
          <input className="form-control mb-3" type="password" required value={form.password} onChange={e=>setForm({...form,password:e.target.value})} data-testid="reg-password" />
          <label className="form-label">Phone (optional)</label>
          <input className="form-control mb-3" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} data-testid="reg-phone" />
          <label className="form-label">Register as</label>
          <select className="form-select mb-3" value={form.role} onChange={e=>setForm({...form,role:e.target.value})} data-testid="reg-role">
            <option value="customer">Customer</option>
            <option value="business_owner">Business Owner</option>
          </select>
          <button className="btn-ap w-100" type="submit" disabled={busy} data-testid="reg-submit">{busy ? 'Creating…' : 'Create account'}</button>
        </form>
        <div className="text-center mt-3 small">
          Already have an account? <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
}
